<div class="card">
    <div class="card-title">
        <h5 class="d-inline-block card-title">
            {{ model.name }} - {{ model.team }}
        </h5>
        <span class="d-inline-block float-right">{{ model.client }}</span>
    </div>
    <div class="card-body">
        @for (personnel of model.personnelOverview; track personnel) {
            <div>
                <span class="card-text">{{ personnel }}</span>
                <br />
            </div>
        }
        @if (model.fuelStats.length > 0) {
            <div class="mt-4">
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-3 text-right">Dispensed</div>
                    <div class="col-2 text-right"><!--BR--></div>
                    <div class="col-2 text-right"><!--OH--></div>
                    <div class="col-2 text-right"><!--Cap--></div>
                </div>
                <hr class="m-1" />
                @for (fuelInfo of model.fuelStats; track fuelInfo) {
                    <div>
                        <div class="row">
                            <div class="col-3">{{ fuelInfo.fuelType }}</div>
                            <div class="col-3 text-right">
                                {{ fuelInfo.gallons | number }}
                            </div>
                            <div class="col-2 text-right"></div>
                            <!--BR (Burn Rate)-->
                            <div class="col-2 text-right"></div>
                            <!--OH (On Hand)-->
                            <div class="col-2 text-right"></div>
                            <!--Cap (Capacity)-->
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
